import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from './AuthContext';
import CreatePost from './CreatePost';
import AuthPrompt from './AuthPrompt';

const ComposePage = ({ relays }) => {
  const [searchParams] = useSearchParams();
  const { publicKey } = useAuth();
  const [showAuthPrompt, setShowAuthPrompt] = useState(false);
  const navigate = useNavigate();
  
  // Get the pre-filled content from URL parameters
  const prefilledContent = searchParams.get('content') || '';

  useEffect(() => {
	// If user is not logged in, show auth prompt
	if (!publicKey) {
	  setShowAuthPrompt(true);
	}
  }, [publicKey]);

  const handlePostCreated = () => {
	// After successful post, navigate to home
	navigate('/', { replace: true });
  };

  const handleAuthClose = () => {
	// If user closes auth prompt without logging in, go to home
	setShowAuthPrompt(false);
	navigate('/', { replace: true });
  };

  return (
	<div className="compose-page">
	  <div className="compose-container">
		<h2>Create Post</h2>
		
		<CreatePost 
		  initialContent={prefilledContent}
		  onPostCreated={handlePostCreated}
		  relays={relays}
		  enforceGovLink={true}
		/>
	  </div>

	  {showAuthPrompt && (
		<AuthPrompt onClose={handleAuthClose} />
	  )}
	</div>
  );
};

export default ComposePage;